import React from 'react';

type SelectInput = {
  size: string;
  option?: string;
  options?: string[];
  className?: string;
  onChange?: () => void;
};

const SelectInput = ({ size, option, className }: SelectInput) => {
  const selectSize = (size: string) => {
    switch (size) {
      case 'sm':
        return 'w-[76px]';
      case 'md':
        return 'md:w-[120px]';
      case 'lg':
        return 32;
      case 'xl':
        return 36;
      default:
        return 'w-[76px]';
    }
  };
  return (
    <div className='flex justify-center'>
      <div className={`${selectSize(size)}`}>
        <select
          // value={option}
          className={`form-select appearance-none
      block
      w-full
      px-2
      py-1.5
      text-xs
      font-normal
      text-gray-700
      bg-white bg-clip-padding bg-no-repeat
      border border-solid border-gray-300
      rounded
      transition
      ease-in-out
      font-poppins
      m-0
      focus:text-gray-700  focus:border-green ${className} `}
          aria-label='Default select example'
        >
          <option>{option}</option>
        </select>
      </div>
    </div>
  );
};

export default SelectInput;
